export const FETCH_FEED_REQUEST = "FETCH_FEED_REQUEST";
export const FETCH_FEED_SUCCESS = "FETCH_FEED_SUCCESS";
export const FETCH_FEED_FAIL = "FETCH_FEED_FAIL";
export const PREPEND_FEED_POST = "PREPEND_FEED_POST";
export const PREPEND_FEED_STORY = "PREPEND_FEED_STORY";
